
import Layout from '../views/layout/App.vue'
import Empty from '../views/layout/Empty.vue'
export default     {
    path: '/allocation',
    name: ' Allocation',
    meta: {
        title: '任务分配管理',
        keepAlive: false
    },
    component: Layout,
    redirect: '/allocation/testQuestionsAllocation',
    children: [
        {
            path: 'testQuestionsAllocation',
            name: 'TestQuestionsAllocation',
            meta: {
                title: '试题分配列表',
                keepAlive: true
            },
            component: resolve => require(['@/views/allocation/testQuestionsAllocation/Index.vue'], resolve),
        },
        {
            path: 'knowledgeAllocation',
            name: 'knowledgeAllocation',
            meta: {
                title: '知识点分配列表',
                keepAlive: true
            },
            component: resolve => require(['@/views/allocation/knowledgeAllocation/Index.vue'], resolve),
        },
        {
            path: 'knowledgeAllocation',
            meta: {
                title: '知识点分配列表',
                keepAlive: false
            },
            component: Empty,
            redirect: '/allocation/knowledgeAllocation',
            children: [
                {
                    path: 'knowledgDetail',
                    name: 'KnowledgDetail',
                    meta: {
                        title: '预览知识点',
                        keepAlive: false
                    },
                    component: resolve => require(['@/views/knowledge/knowledgeList/KnowledgDetail.vue'], resolve)

                },
                {
                    path: '/allocation/knowledgeAllocation/knowledgDetail',
                    name: 'knowledgDetails',
                    meta: {
                        title: '预览知识点',
                        keepAlive: false
                    },
                    component: Empty,
                    children: [{
                        path: '/allocation/knowledgeAllocation/knowledgDetail/radioTestA1Detail',
                        name: 'radioTestA1Detailk',
                        meta: {
                            title: '预览试题',
                            keepAlive: false
                        },
                        component: resolve => require(['@/views/testBaseManage/radioTest/RadioTestA1Detail.vue'], resolve),
        
                    },{
                        path: '/allocation/knowledgeAllocation/knowledgDetail/radioTestA3Detail',
                        name: 'RadioTestA3Detailk',
                        meta: {
                            title: '预览试题',
                            keepAlive: false
                        },
                        component: resolve => require(['@/views/testBaseManage/radioTest/RadioTestA3Detail.vue'], resolve),
        
                    },{
                        path: '/allocation/knowledgeAllocation/knowledgDetail/radioTestBDetail',
                        name: 'RadioTestBDetailk',
                        meta: {
                            title: '预览试题',
                            keepAlive: false
                        },
                        component: resolve => require(['@/views/testBaseManage/radioTest/RadioTestBDetail.vue'], resolve),
        
                    }]

                }
            ]
        },
    ]
}


